import EquationValue, {
  variables,
  VariableType,
} from "../../../Model/Value/EquationValue"
import RandomNumberGenerator from "../../RandomNumberGenerator"
import NumberValue from "../../../Model/Value/NumberValue"
import { DivisionSign, signs } from "../../../Model/Value/DivisionValue"
import getDivisors from "../../../util/factorize"
import ValueGeneratorInterface from "../ValueGeneratorInterface"

export default class DivisionEquationValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(value: number): boolean {
    return getDivisors(value).length > 2
  }

  public generate(value: number): EquationValue {
    const variable: VariableType =
      this.randomNumberGenerator.pick<VariableType>(variables)
    const divisionSign: DivisionSign =
      this.randomNumberGenerator.pick<DivisionSign>(signs)

    if (this.randomNumberGenerator.coin()) {
      // a / x = b
      const b: number = this.randomNumberGenerator.randomInt(
        3,
        Math.round(Math.sqrt(value)),
      )
      return new EquationValue(
        new NumberValue(value * b),
        new NumberValue(value),
        new NumberValue(b),
        variable,
        `a ${divisionSign} x = b`,
      )
    }

    // x / a = b
    const divisors: number[] = getDivisors(value).filter(
      (d: number): boolean => d !== 1 && d !== value,
    )

    const a: number = this.randomNumberGenerator.pick(divisors)
    const b: number = value / a

    return new EquationValue(
      new NumberValue(a),
      new NumberValue(value),
      new NumberValue(b),
      variable,
      `x ${divisionSign} a = b`,
    )
  }
}
